"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleAttackAbilityHandler = exports.DoubleAttackActorAbilityFactory = exports.DoubleAttackAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
class DoubleAttackAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DoubleAttack;
        this.__typeName = "DoubleAttack";
    }
}
exports.DoubleAttackAbilityArgs = DoubleAttackAbilityArgs;
let DoubleAttackActorAbilityFactory = class DoubleAttackActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DoubleAttack", "Self", 0);
    }
};
DoubleAttackActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DoubleAttack")
], DoubleAttackActorAbilityFactory);
exports.DoubleAttackActorAbilityFactory = DoubleAttackActorAbilityFactory;
let DoubleAttackAbilityHandler = class DoubleAttackAbilityHandler {
    init(sequence, container, actorId) {
        container.applyEffect(sequence, actorId, actorId, new core_1.EchoEffectArgs(1));
    }
    activate(sequence, container, ability) { }
};
DoubleAttackAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DoubleAttack)
], DoubleAttackAbilityHandler);
exports.DoubleAttackAbilityHandler = DoubleAttackAbilityHandler;
